import { EncryptionTypesEnum } from '../enums/encryptionTypesEnum';

export default [
    { id: EncryptionTypesEnum.None, text: 'None'},
    { id: EncryptionTypesEnum.Tls, text: 'TLS' },
    { id: EncryptionTypesEnum.Ssl, text: 'SSL' }
];


// WEBPACK FOOTER //
// ./src/services/encryption/encryptionTypes.js